import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

export const PrivateRoute = ({ children, requiredRole }) => {
  const { isAuthenticated, userLoading, user } = useSelector(
    (state) => state.auth
  );
  const userRole = user?.role;
  const location = useLocation();

  console.log(isAuthenticated, userLoading, userRole);
  console.log('PrivateRoute Hit →', location.pathname);

  useEffect(() => {
    if (userLoading) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto'; // Always clean up
    };
  }, [userLoading]);

  if (userLoading) {
    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999,
          backgroundColor: 'white',
        }}
      >
        <div className='loader'></div>
      </div>
    );
  }

  if (!isAuthenticated && !userLoading) {
    return <Navigate to='/login' state={{ from: location.pathname }} replace />;
  }

  if (requiredRole && userRole !== requiredRole) {
    return <Navigate to='/unauthorized' replace />;
  }

  return children;
};

export default PrivateRoute;
